import { render, staticRenderFns } from "./AirPreferredVendors.vue?vue&type=template&id=4d86c7a2&scoped=true&"
import script from "./AirPreferredVendors.vue?vue&type=script&lang=js&"
export * from "./AirPreferredVendors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d86c7a2",
  null
  
)

export default component.exports